import Vue from 'vue'
import formatCurrency from 'format-currency'

export const DEBUG = process.env.NODE_ENV !== 'production'
export const APP_NAME = 'Synergy Courier'
export const GOOGLE_MAPS_KEY = 'AIzaSyAH2H2l7eX0osBFtrzJ-WJeVmdf-FG7oUk'
export const PRIMARY_COLOR = '#1A75BA'
export const ACCENT_COLOR = '#FFC908'
// export const REMOTE_URL = 'http://35.184.187.70'
export const REMOTE_URL = 'https://messengerdev2.programminghelpers.com'
// export const REMOTE_URL = 'https://cubemessenger.cube-messenger.com'
// export const REMOTE_URL = 'http://127.0.0.1:8000'
export const LOCAL_URL = 'http://localhost:3000'

let App = {
  isDebug: DEBUG,
  url: REMOTE_URL,
  googleMapsKey: GOOGLE_MAPS_KEY,
  googleGeocodeUrl: 'https://maps.googleapis.com/maps/api/geocode/json',
  googleDirectionsUrl: 'https://maps.googleapis.com/maps/api/directions/json',
  // eslint-disable-next-line
  log: function(logData) {
    if (this.isDebug) {
      console.info(logData)
    }
  },
  imageUrl(relativePath) {
    // return this.url + '/storage/' + relativePath
    return this.url + '/public/storage/' + relativePath
  },
  fileUrl(relativePath) {
    // return this.url + '/storage/' + relativePath
    return this.url + '/public/storage/' + relativePath
  },
  dummyImage() {
    return `https://unsplash.it/150/300?image=${Math.floor(
      Math.random() * 100
    ) + 1}`
  },
  formatMoney: function(val) {
    let opts = { format: '%s%v', symbol: 'KES ' }
    return formatCurrency(Math.ceil(val), opts)
  },
  formatPhone: function(val) {
    return '254' + val.substring(1)
  },
  timeToMin: function(val) {
    return Math.round((val / 60) * 100) / 100 + ' Min'
  },
  distanceToKm: function(val) {
    return Math.round((val / 1000) * 100) / 100 + ' Km'
  },
  capitalizeFirstLetter: function(string) {
    return string.charAt(0).toUpperCase() + string.slice(1)
  },
  generateDocumentName: function(string) {
    return string.replace(/\s/g, '_').toLowerCase()
  },
  primaryColor: PRIMARY_COLOR,
  accentColor: ACCENT_COLOR
}

Vue.prototype.$app = App
Vue.config.productionTip = true
Vue.prototype.$appName = APP_NAME
Vue.prototype.$actions = {
  addedDelivery: 'addedDelivery',
  addedSubscription: 'addedSubscription',
  collapsedDrawer: 'collapsedDrawer',
  clickedToolbarSideIcon: 'clickedToolbarSideIcon',
  clickedToolbarCartIcon: 'clickedToolbarCartIcon',
  placedOrder: 'placedOrder',
  requestedService: 'requestedService',
  addedAppointment: 'addedAppointment',
  approved: 'approved',
  rejected: 'rejected',
  signedIn: 'signedIn',
  signedUp: 'signedUp'
}
export default App



// WEBPACK FOOTER //
// ./src/app.js